import React from 'react';
import Box from '@prezzee/ribbon-ui/lib/components/Box';
import Typography from '@prezzee/ribbon-ui/lib/components/Typography';
import Button from '@prezzee/ribbon-ui/lib/components/Button';
import CmsImage from 'components/CmsImage';
import useDisclosure from '@prezzee/ribbon-ui/lib/hooks/useDisclosure';
import { useProduct } from 'contexts/ProductPageContext';
import RetailerListModal from '../RetailerListModal';

type ZagBuyingPromptProps = {
  imageUrl: string;
  title: string;
  description: string;
  modalLinkText?: string;
};

const ZagBuyingPrompt = ({ imageUrl, title, description, modalLinkText }: ZagBuyingPromptProps) => {
  const retailerListDialog = useDisclosure();
  const { sku } = useProduct();

  const onModalClick = () => {
    retailerListDialog.onOpen();
  };

  return (
    <Box display="flex" alignItems={'center'} p="5" backgroundColor="pink.400" borderRadius="8" mb="4">
      <Box mr="4">{imageUrl && <CmsImage src={imageUrl} alt="Zag Logo" width={78} height={78} />}</Box>
      <Box>
        <Typography variant="h6" as="h2" mb="3">
          {title}
        </Typography>
        <Typography variant="body2" fontWeight="normal">
          {description}{' '}
          <Button variant="link" textDecoration="underline" onClick={onModalClick}>
            {modalLinkText}
          </Button>
        </Typography>
      </Box>
      {retailerListDialog.isOpen && (
        <RetailerListModal
          showDefaultStore
          isOpen
          onClose={retailerListDialog.onClose}
          uid={sku?.uid}
          title="Available brands"
        />
      )}
    </Box>
  );
};

export default ZagBuyingPrompt;
